import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useDispatch } from 'react-redux';
import { setBalance } from '../../store/tradeSlice';

const DepositSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const orderId = searchParams.get('order');
    const gateway = searchParams.get('gateway');
    if (orderId && gateway) {
      api.get(`/deposit/verify?orderId=${orderId}&gateway=${gateway}`).then(res => {
        if (res.data.verified) {
          api.get('/user/balance').then(r => dispatch(setBalance(r.data.balance)));
        }
      }).finally(() => setTimeout(() => navigate('/terminal'), 2000));
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--color-bg)' }}>
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute w-[700px] h-[700px] rounded-full top-[-260px] right-[-200px] animate-float"
          style={{ background: 'radial-gradient(circle, rgba(46,54,66,0.08), transparent 65%)' }} />
        <div className="absolute w-[600px] h-[600px] rounded-full bottom-[-200px] left-[-160px] animate-float animation-delay-2000"
          style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.05), transparent 65%)' }} />
      </div>
      <div className="relative z-10 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: 'var(--color-greenBg)', border: '2px solid var(--color-greenBorder)', boxShadow: '0 0 30px rgba(16,185,129,0.2)' }}>
          <i className="fas fa-check-circle text-4xl" style={{ color: 'var(--color-green)' }} />
        </div>
        <h2 className="font-syne text-3xl font-extrabold mb-3" style={{ color: 'var(--color-text)' }}>Payment Successful!</h2>
        <p className="text-sm font-mono mb-6" style={{ color: 'var(--color-textSecondary)' }}>Your deposit has been confirmed</p>
        <div className="flex items-center justify-center gap-2">
          <div className="w-5 h-5 border-2 rounded-full animate-spin" style={{ borderColor: 'var(--color-orange)', borderTopColor: 'transparent' }} />
          <span className="text-xs font-mono" style={{ color: 'var(--color-textDim)' }}>Redirecting to terminal...</span>
        </div>
      </div>
      <style>{`
        @keyframes float { 0%,100% { transform:translate(0,0) } 50% { transform:translate(28px,-28px) } }
        .animate-float { animation:float 20s ease-in-out infinite }
        .animation-delay-2000 { animation-delay:-8s }
      `}</style>
    </div>
  );
};

export default DepositSuccess;